import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { NavController, Events } from 'ionic-angular';
import { ProfileServiceProvider } from './../../providers/profile-service/profile-service';
import { StorageServiceProvider } from './../../providers/storage-service/storage-service';

@Component({
  selector: 'lubbu-header-gift',
  templateUrl: 'lubbu-header-gift.html'
})
export class LubbuHeaderGiftComponent {
  @Input() title: string;

  redBox;

  constructor(
    private location: Location,
    public navCtrl: NavController,
    public events: Events,
    public profileService: ProfileServiceProvider,
    public storageService: StorageServiceProvider
  ) {
    this.redBox = this.storageService.getStorage('redBox') || false;

    events.subscribe('gift-added', event => {
      const user = this.profileService.getUser();
      if (user.id === event.data.request.profile_id) {
        this.storageService.setStorage('redBox', true);
        this.redBox = true;
      }
    });
  }

  /**
   * Cancel action
   *
   * @memberof LubbuHeaderComponent
   */
  cancel(): void {
    this.location.back();
  }

  /**
   * Goto my gift
   *
   * @memberof LubbuHeaderComponent
   */
  myGifts() {
    this.redBox = false;
    this.storageService.removeStorage('redBox');
    this.navCtrl.push('MyGiftsPage');
  }

  /**
   * Goto home tab
   *
   * @memberof LubbuHeaderComponent
   */
  goHome() {
    this.events.publish('my-world');
  }
}



// WEBPACK FOOTER //
// ./src/components/lubbu-header-gift/lubbu-header-gift.ts